import { z } from "zod";

export const EmployeeSchema = z.object({
  EmpId: z.number(),
  NameEn: z.string(),
  NameAr: z.string(),
  WorkCompanyId: z.number(),
  CompanyId: z.number(),
  SectionId: z.number(),
  EmpNo: z.string(),
  NationId: z.number(),
});
export type Employee = z.infer<typeof EmployeeSchema>;
